var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('sidebar')],1),_c('el-container',[_c('el-header',[_c('my-header')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }